import { TFunction } from "next-i18next";
import { withCdnUrl } from "@smile2impress/attraction-utils";
import {
    UTSLocale,
    UTSLocaleToCountryVersion,
} from "@smile2impress/attraction-constants";

import { mergeContent } from "utils/mergeContent";
import { PageContentProps } from "content/content.types";
import {
    OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE,
    PRIVACY_POLICY_LINKS_BY_LOCALE,
    UrlsConfig,
} from "configs/urlsConfig";
import contacts from "configs/contacts";
import { SocialTypes } from "constants/enum";
import { FooterLinkProps } from "components/Relaunch/Footer/components/FooterLink";

import defaultContent from "./common";

const pageContent = (t: TFunction, { locale }: PageContentProps) => {
    const content = defaultContent(t, { locale });

    return mergeContent(content, {
        footer: {
            company: {
                links: [
                    {
                        id: "whyImpress",
                        name: t("global:whyImpressPageTitle"),
                        link: UrlsConfig.WHY_IMPRESS,
                    },
                    {
                        id: "press",
                        name: t("global:pressPageTitle"),
                        link: `mailto:${contacts.emailPress.link}`,
                    },
                    {
                        id: "careers",
                        name: t("global:careersPageTitle"),
                        link: "https://www.linkedin.com/company/impress-orthodontics/jobs/",
                        target: "_blank",
                    },
                    {
                        id: "blog",
                        name: t("global:blogPageTitle"),
                        link: UrlsConfig.BLOG,
                        target: "_self",
                    },
                    {
                        id: "offersAndDiscounts",
                        name: t("navigationMenuRelaunch:offersAndDiscounts"),
                        link: OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE[locale],
                    },
                    {
                        id: "studentbeans",
                        name: t("navigationMenuRelaunch:studentBeans"),
                        link: UrlsConfig.STUDENT_BEANS,
                    },
                ],
            },
            legal: {
                title: t("global:legalNoticeFooterTitle"),
                links: [
                    {
                        id: "privacyPolicyPage",
                        name: t("global:privacyPolicy"),
                        link: PRIVACY_POLICY_LINKS_BY_LOCALE[locale],
                    },
                    {
                        id: "cookiesPage",
                        name: t("global:cookiesPolicy"),
                        link: withCdnUrl(
                            `${UrlsConfig.POLICY}/cookies-policy_${UTSLocaleToCountryVersion[locale]}.pdf`
                        ),
                    },
                    {
                        id: "legalNoticePage",
                        name: t("global:legalNoticeFooterText"),
                        link: withCdnUrl(
                            `${UrlsConfig.POLICY}/aviso-legal_${UTSLocaleToCountryVersion[locale]}.pdf`
                        ),
                    },
                    {
                        id: "complaintsBook",
                        name: t("global:complaintsBook"),
                        target: "_blank",
                        link: "https://www.livroreclamacoes.pt/Inicio/",
                    },
                    {
                        id: "creditMediation",
                        name: t("global:creditMediation"),
                        link: withCdnUrl(
                            `${UrlsConfig.POLICY}/credit-mediation_${UTSLocaleToCountryVersion[locale]}.pdf`
                        ),
                    },
                ],
            },
            support: {
                links: content.footer.support.links.map((link) => {
                    if (link?.id !== SocialTypes.WA) return link;
                    return {
                        ...link,
                        link: contacts.whatsapp[UTSLocale.PORTUGAL_PT]
                            .newPatientsLink,
                    } as FooterLinkProps;
                }),
            },
            product: {
                title: t("global:productFooterText"),
                links: [
                    {
                        id: "aligners",
                        name: t("global:alignersPageTitle"),
                        link: UrlsConfig.ALIGNERS,
                    },
                    {
                        id: "teens",
                        name: t("global:teensPageTitle"),
                        link: UrlsConfig.TEENS,
                    },
                    {
                        id: "kids",
                        name: t("global:kidsPageTitle"),
                        link: UrlsConfig.KIDS,
                    },
                    {
                        id: "malocclusion",
                        name: t("navigationMenuRelaunch:malocclusion"),
                        link: UrlsConfig.MALOCCLUSION,
                    },
                    {
                        id: "retainers",
                        name: t("global:nightRetainersPageTitle"),
                        link: UrlsConfig.RETAINERS_SUBSCRIPTION,
                    },
                    {
                        id: "whitening",
                        name: t("global:whiteningPageTitle"),
                        link: UrlsConfig.WHITENING,
                    },
                    {
                        id: "prices",
                        name: t("global:pricePageTitle"),
                        link: UrlsConfig.PRICES,
                    },
                    {
                        id: "results",
                        name: t("global:resultsPageTitle"),
                        link: UrlsConfig.RESULTS,
                    },
                ],
            },
        },
    });
};

export default pageContent;
